// export const backend_url = "http://localhost:3050";
// export const backend_url = "https://api.staging.payserve.co.ke";
// export const backend_url = "https://api.sandbox.payserve.co.ke";
// export const backend_url = "https://api.payserve.co.ke";
export const backend_url =
  process.env.REACT_APP_BASE_URL ||
  "https://sandbox.payserve.co.ke/swan_backend";
export const getLevyBalancesURL = "/api/app/levy_management/get_levy_balances";
export const checkEmailAndPasswordURL = "/api/auth/check_email_and_password";
export const loginURL = "/api/auth/login";
export const forgotPasswordURL = "/api/auth/forgot_password";
export const resetPasswordURL = "/api/auth/reset_password";
export const codeVerificationURL = "/api/auth/otp";
export const resendCodeURL = "/api/auth/resend_code";
export const verifyOTPURL = "/api/auth/verify_otp";

export const checkTokenExpirationURL = "/api/auth/check_jwt_expiration";
export const addWaterConcentratorURL = "/api/core/water/add_concentrator";
export const getWaterConcentratorsURL = "/api/core/water/get_concentrators";
export const importWaterConcentratorsURL =
  "/api/core/water/import_concentrators";
export const addWaterMeterURL = "/api/core/water/add_water_meter";
export const getWaterMetersURL = "/api/core/water/get_water_meters";
export const importWaterMetersURL = "/api/core/water/import_water_meters";
export const confirmCompanyNameURL =
  "/api/core/company_management/confirm_company_name";
export const getCompaniesURL = "/api/core/company_management/get_companies";
export const addCompanyURL = "/api/core/company_management/add_company";
export const addExistingCompanyToUserURL =
  "/api/core/user_management/add_a_existing_company_to_user";
export const addNewCompanyToUserURL =
  "/api/core/user_management/add_a_new_company_to_user";
export const getCompanyUsersURL = "/api/core/user_management/get_company_users";
export const confirmUserEmailURL =
  "/api/core/user_management/confirm_user_email";
export const getSitesURL = "/api/core/site_management/get_sites";
export const addSiteURL = "/api/core/site_management/add_site";
export const getProjectsURL = "/api/core/project_management/get_projects";
export const releaseUnitFieldURL =
  "/api/core/unit_management/release_unit_field";
export const getTransactionsURL = "";
export const getWaterMeterAccountURL = "";
export const getAPIMetricsURL = "/api/core/api_management/get_metrics";
export const getListOfFacilities =
  "/api/app/user_management/get_list_of_facilities";
export const getCompanyInformationURL =
  "/api/app/settings_management/get_company_information";
export const finishOnboardingURL =
  "/api/app/facility_management/finish_onboarding";
export const getFacilityUnits = "/api/app/unit_management/get_facility_units";
export const addNewUserURL = "/api/app/user_management/add_user";
export const getUsersURL = "/api/app/user_management/get_users";
export const getPropertyAdminAndFinanceURL =
  "/api/app/user_management/get_property_admin_and_finance";
export const updateUserURL = "/api/app/user_management/update_user";
export const getFacilityURL = "/api/core/facility_management/get_facility";
export const getFacilities = "/api/app/unit_management/get_facilities";
export const getUnitsForFacility =
  "/api/app/facility_management/get_units_for_facility";
export const addDigitaxProfileURL =
  "/api/app/facility_management/add_facility_digitax_profile";
export const getDigitaxProfilesURL =
  "/api/app/facility_management/get_facility_digitax_profiles";
export const addDigitaxAPIkeyURL =
  "/api/app/facility_management/add_facility_digitax_api";
export const getDigitaxConfigURL =
  "/api/app/facility_management/get_digitax_config";
export const testDigitaxConnectionURL =
  "/api/app/facility_management/test_digitax_connection";

// Move-In integration for PayServe property-management units — disabled, pending integration
// export const getFacilityMoveInUnitsURL = "/api/app/move_in/units";
// export const upsertFacilityMoveInListingURL = "/api/app/move_in/units"; // + /:facilityId/:unitId/listing
// export const submitFacilityMoveInListingURL = "/api/app/move_in/units"; // + /:facilityId/:unitId/submit
// export const getFacilityMoveInIntakeURL = "/api/app/move_in/intake"; // + /:facilityId
// export const convertMoveInDealToLeaseURL = "/api/app/move_in/deals"; // + /:dealId/convert
export const AddNewCustomerURL =
  "/api/app/customer_management/add_new_customer";
export const resendLoginCredentials =
  "/api/app/customer_management/resend_credentials";
export const ImportCustomersURL =
  "/api/app/customer_management/import_customers";
export const getCustomersURL = "/api/app/customer_management/get_customers";
export const importKraPinsURL = "/api/app/customer_management/import_kra_pins";
export const addSecondaryContact2URL =
  "/api/app/customer_management/add_secondary_contact2";
export const getSecondaryContactsURL =
  "/api/app/customer_management/get_secondary_contacts";
export const getCustomerURL = "/api/app/customer_management/get_customer";
export const updateCustomer = "/api/app/customer_management/update_customer";
export const changeUserTypeURL =
  "/api/app/customer_management/change_user_type";
export const updateKinURL = "/api/app/customer_management/update_nextofkin";
export const addKinURL = "/api/app/customer_management/add_nextofkin";
export const getCustomerUnits =
  "/api/app/customer_management/get_customer_units";
export const addUnoccupiedUnitToCustomer =
  "/api/app/customer_management/add_unoccupied_unit_to_customer";
export const finishDeactivationUrl =
  "/api/app/customer_management/deactivate_customer";
export const moveCustomerUrl = "/api/app/customer_management/move_customer";
export const deactivateLandlordURL =
  "/api/app/customer_management/deactivate_landlord";
export const addLandlordURL = "/api/app/customer_management/add_landlord";

//property management
export const getPropertyManagedUnitsURL =
  "/api/app/property_management/get_property_managed_units";
export const get_property_managed_invoices =
  "/api/app/property_management/invoices/get_property_managed_invoices";
export const get_pm_invoiceURL =
  "/api/app/property_management/invoices/get_pm_invoice";
export const getPropertyManagerRevenueURL =
  "/api/app/property_management/get_property_manager_revenue";
export const calculateAndSavePropertyManagerRevenueURL =
  "/api/app/property_management/calculate_and_save_property_manager_revenue";
export const savePropertyManagerRevenueURL =
  "/api/app/property_management/save_property_manager_revenue";
export const getPropertyManagedCustomersURL =
  "/api/app/property_management/get_property_managed_customers";
export const createPropertyManagerContractURL =
  "/api/app/property_management/contracts/create_property_manager_contract";
export const getPropertyManagerContractsURL =
  "/api/app/property_management/contracts/get_property_manager_contracts";
export const getPropertyManagerContractByIdURL =
  "/api/app/property_management/contracts/get_property_manager_contract_by_id";
export const terminatePropertyManagerContractURL =
  "/api/app/property_management/contracts/terminate_property_manager_contract";
export const editPropertyManagerContractURL =
  "/api/app/property_management/contracts/edit_property_manager_contract";
export const getPMRevenueStreamsURL =
  "/api/app/property_management/revenue/get_revenue_streams";
export const processPMRevenueStreamsURL =
  "/api/app/property_management/revenue/process_revenue_streams";
export const getPMRevenueSettingsURL =
  "/api/app/property_management/revenue/get_settings";
export const updatePMRevenueSettingsURL =
  "/api/app/property_management/revenue/update_settings";
export const getUnitPMRevenueHistoryURL =
  "/api/app/property_management/revenue/get_unit_revenue_history";
export const getPMRevenueReceiptURL =
  "/api/app/property_management/revenue/get_receipt";
export const generatePMRevenueReportURL =
  "/api/app/property_management/revenue/generate_report";

// Visitor and Access Routes
export const getVisitLogsForFacilityURL =
  "/api/app/visitor_management/get_visitor_logs";
export const searchByOtp = "/api/app/visitor_management/search_by_otp";
export const confirmQRDataURL = "/api/app/visitor_management/confirm_qr_data";
export const handleAllowVisitorURL =
  "/api/app/visitor_management/allow_verified_visitor";
export const confirmManualDataURL = "/api/app/visitor_management/manual_entry";
export const deliveryRegistrationURL =
  "/api/app/visitor_management/delivery_registration";
export const getDivisionArray = "/api/app/facility_management/get_divisions";
export const getUnitUrl = "/api/app/unit_management/get_unit";
export const getUnitOccupantsURL =
  "/api/app/unit_management/get_unit_occupants";
export const updateUnit = "/api/app/unit_management/update_unit";
export const getUnitAssetsURL = "/api/app/unit_management/get_unit_assets";
export const addUnitAssetURL = "/api/app/unit_management/add_new_unit_asset";
export const deleteUnitAssetURL = "/api/app/unit_management/delete_unit_asset";
export const visitorPreRegistrationURL =
  "/api/app/visitor_management/visitor_pre_registration";
export const getVisitLogURL = "/api/app/visitor_management/get_visit_log";
export const exitVisitLogURL = "/api/app/visitor_management/exit_visit_log";
export const allowVisitURL = "/api/app/visitor_management/allow_visit";
export const allowVisitorURL = "/api/app/visitor_management/allow_visitor";
export const EntryAndExitURL =
  "/api/app/entry_and_exit_management/add_entry_and_exit";
export const getEntriesAndExitsForFacility =
  "/api/app/entry_and_exit_management/get_entries_and_exits_for_facility";
export const editEntriesAndExitsForFacility =
  "/api/app/entry_and_exit_management/edit_entries_and_exits_for_facility";
export const deleteEntriesAndExitsForFacility =
  "/api/app/entry_and_exit_management/delete_entries_and_exits_for_facility";
export const disableEntriesAndExitsForFacility =
  "/api/app/entry_and_exit_management/disable_entries_and_exits_for_facility";
export const GuardRegistrationURL = "/api/app/guard_management/add_guard";
export const ReceptionistRegistrationURL =
  "/api/app/reception_management/add_receptionist";
export const getFacilityReceptionists =
  "/api/app/reception_management/get_receptionists";
export const editFacilityReceptionist =
  "/api/app/reception_management/edit_receptionist";
export const deleteFacilityReceptionist =
  "/api/app/reception_management/delete_receptionist";
export const getFacilityGuards =
  "/api/app/guard_management/get_facility_guards";
export const getGuardTime = "/api/app/guard_management/get_guard_time";
export const editFacilityGuard =
  "/api/app/guard_management/edit_facility_guard";
export const deleteFacilityGuard =
  "/api/app/guard_management/delete_facility_guard";
export const disableFacilityGuard =
  "/api/app/guard_management/disable_facility_guard";
export const updateFacilityInfo =
  "/api/app/settings_management/update_facility";
export const addDocumentTypeURL =
  "/api/app/settings_management/add_document_type";
export const getDocumentTypesURL =
  "/api/app/settings_management/get_document_types";
// End visitor and access routes

export const addLevyType = "/api/app/levy_management/add_levy_type";
export const getLevyTypes = "/api/app/levy_management/get_levy_types";
export const deleteLevyType = "/api/app/levy_management/delete_levy_type";
export const editLevyType = "/api/app/levy_management/edit_levy_type";

// LEVY DEPOSITS

export const getAllDeposits =
  "/api/app/levy_management/levy_deposits/get_all_deposits";
export const getSingleDeposit =
  "/api/app/levy_management/levy_deposits/get_deposit";
export const refundDeposit =
  "/api/app/levy_management/levy_deposits/refund_deposit";
export const updateDeposit =
  "/api/app/levy_management/levy_deposits/update_deposit";
export const payDeposit = "/api/app/levy_management/levy_deposits/pay_deposit";

export const addLevy = "/api/app/levy_management/add_levy";
export const editLevy = "/api/app/levy_management/edit_levy";
export const deleteLevy = "/api/app/levy_management/delete_levy";
export const disableLevy = "/api/app/levy_management/disable_levy";
export const getLevies = "/api/app/levy_management/get_levies";
// Get single levy
export const getLevyURL = `/api/app/levy_management/get_levy`;
export const addLevySettings = "/api/app/levy_management/add_levy_settings";
export const showLevySettings = "/api/app/levy_management/show_levy_settings";
export const editLevySettings = "/api/app/levy_management/edit_levy_settings";
export const addContract = "/api/app/levy_management/add_contract";
export const getContracts = "/api/app/levy_management/get_contracts";
export const getWHTrecordsURL =
  "/api/app/levy_management/get_withholdingtax_records";
export const editContract = "/api/app/levy_management/edit_contract";
export const disableContract = "/api/app/levy_management/disable_contract";
export const deleteContract = "/api/app/levy_management/delete_contract";
export const terminateContractUrl =
  "/api/app/levy_management/terminate_levy_contract";
export const addReminder = "/api/app/levy_management/reminders/add_reminder";
export const addPenalty = "/api/app/levy_management/penalty/add_penalty";
export const updatePenalty =
  "/api/app/levy_management/penalty/update_penalty_status";
export const updateReminder =
  "/api/app/levy_management/reminders/update_reminder_status";
export const deleteReminder =
  "/api/app/levy_management/reminders/delete_reminder";
export const deletePenalty = "/api/app/levy_management/penalty/delete_penalty";
export const facilityReminders =
  "/api/app/levy_management/get_facility_reminders";
export const facilityPenalties =
  "/api/app/levy_management/get_facility_penalties";
export const fetchFacilityPaymentDetails =
  "/api/core/payment_details/get_facility_payment_details";
export const getLeviesURL = "/api/app/levy_management/get_levies";
export const addTaxRate = "/api/app/settings_management/add_or_update_tax_rate";
export const getTaxRates = "/api/app/settings_management/get_tax_rates";
export const deleteTaxRate = "/api/app/settings_management/delete_tax_rate";

export const createTicketURL = "/api/app/ticket_management/create_ticket";
export const getTicketsURL = "/api/app/ticket_management/get_tickets";
export const getTicketURL = "/api/app/ticket_management/get_ticket";
export const assignTicketURL = "/api/app/ticket_management/assign_ticket";
export const getAssignedTicketsURL =
  "/api/app/ticket_management/get_assigned_tickets";
export const approveReviewURL = "/api/app/ticket_management/approve_ticket";
export const closeTicketURL = "/api/app/ticket_management/close_ticket";
export const cancelTicketURL = "/api/app/ticket_management/cancel_ticket";
export const reopenTicketURL = "/api/app/ticket_management/reopen_ticket";
export const markTicketAsReadURL =
  "/api/app/ticket_management/mark_ticket_as_read";
export const getTicketsReportsURL =
  "/api/app/ticket_management/get_ticket_reports";

export const createWorkOrderURL =
  "/api/app/work_order_management/create_work_order";
export const approveComplaintURL =
  "/api/app/ticket_management/approve_complaint";
export const getTicketLandlordURL =
  "/api/app/ticket_management/get_ticket_landlord";
export const finishReviewURL = "/api/app/ticket_management/finish_review";
export const getServices = "/api/app/vas_management/get_maintenance_services";
export const addNewService = "/api/app/vas_management/add_new_service";

export const getVasServices =
  "/api/app/vas_management/get_value_added_services";
export const addNewValueAddedService =
  "/api/app/vas_management/add_new_value_added_service";
export const getValueAddedServices =
  "/api/app/vas_management/get_value_added_services";
export const getVasVendors = "/api/app/vas_management/get_vas_vendors";
export const addVasVendor = "/api/app/vas_management/add_vas_vendor";
export const assignServiceRequest =
  "/api/app/vas_management/assign_service_request";
export const vendorRequestPageURL =
  "/api/app/vas_management/get_vendor_request_page";
export const pmRequestPageURL = "/api/app/vas_management/get_pm_request_page";
export const pmApproveRequestURL = "/api/app/vas_management/pm_approve_quote";
export const pmDenyRequestURL = "/api/app/vas_management/pm_deny_quote";
export const vendorApproveRequestURL =
  "/api/app/vas_management/vendor_approve_service_request";
export const vendorDenyRequestURL =
  "/api/app/vas_management/vendor_deny_service_request";
export const deleteVasVendor = "/api/app/vas_management/delete_vas_vendor";
export const updateVasVendor = "/api/app/vas_management/update_vas_vendor";
export const addServiceRequest = "/api/app/vas_management/add_service_request";
export const addServiceInvoice = "/api/app/vas_management/add_service_invoice";
export const updateServiceRequest =
  "/api/app/vas_management/update_service_request";
export const getServiceInvoicesByCustomer =
  "/api/app/vas_management/get_service_invoices_by_customer";
export const deleteValueAddedService =
  "/api/app/vas_management/delete_value_added_service";
export const getFacilityServiceRequests =
  "/api/app/vas_management/get_facility_service_requests";
export const assignWorkOrder = "/api/app/vas_management/assign_work_order";
export const getWorkOrders = "/api/app/vas_management/get_work_orders";
export const createUnitManagementTemplate =
  "/api/app/vas_management/unit_management_templates/create_template";
export const getUnitManagementTemplates =
  "/api/app/vas_management/unit_management_templates/get_unit_management_templates";
export const getUnitManagementTemplate =
  "/api/app/vas_management/unit_management_templates/get_template";
export const updateUnitManagementTemplate =
  "/api/app/vas_management/unit_management_templates/update_template";
export const deleteUnitManagementTemplate =
  "/api/app/vas_management/unit_management_templates/delete_template";
export const getUnitManagementDataForTemplate =
  "/api/app/vas_management/unit_management_templates/get_data_for_template";
export const assignTemplateToServiceRequest =
  "/api/app/vas_management/assign_template_to_service_request";
//All invoices
export const getVasInvoices = "/api/app/vas_management/get_vas_invoices";
//single invoice
export const getVasInvoice = "/api/app/vas_management/get_vas_invoice_by_id";
//settings management
export const addEmailSettings =
  "/api/app/settings_management/add_email_settings";
export const getEmailSettings =
  "/api/app/settings_management/get_email_settings";
// /api/app/settings_management
export const addSmsSettings = "/api/app/settings_management/add_sms_settings";
export const getSmsSettings = "/api/app/settings_management/get_sms_settings";
//Write endpoints
export const deleteWorkOrder = "/api/app/vas_management/delete_work_order";
export const getInvoice = "/api/app/levy_management/get_invoice_by_id";

//combined invoices management

export const getCombinedInvoices =
  "/api/app/combined_invoices/get_facility_invoices";

// offline invoice
export const getOfflineInvoice =
  "/api/offline/levy_management/invoices/get_invoice_by_id";
export const markInvoiceViewed =
  "/api/app/payment_management/mark_invoice_viewed";

export const deleteInvoice = "/api/app/levy_management/delete_invoice";
export const getFacilityInvoices =
  "/api/app/levy_management/get_facility_invoices";
export const getFacilityInvoiceBalances =
  "/api/app/levy_management/get_facility_invoice_balances";
export const getLeaseInvoice = "/api/app/levy_management/get_lease_invoices";
export const getsingleLeaseInvoice =
  "/api/app/levy_management/invoices/get_single_lease_invoice";
export const add_lease =
  "/api/app/lease_management/lease_agreements/add_lease_agreement";
export const update_lease =
  "/api/app/lease_management/lease_agreements/update_lease";
export const upload_lease_document =
  "/api/app/lease_management/document_management/upload_lease_document";
export const get_lease_documents =
  "/api/app/lease_management/lease_agreements/get_lease_documents";
export const get_leases =
  "/api/app/lease_management/lease_agreements/get_leases";
export const get_lease = "/api/app/lease_management/lease_agreements/get_lease";
export const delete_lease =
  "/api/app/lease_management/lease_agreements/delete_lease";
export const terminate_lease =
  "/api/app/lease_management/lease_agreements/terminate_lease";
export const create_lease_template =
  "/api/app/lease_management/lease_templates/create_lease_template";
export const renew_lease =
  "/api/app/lease_management/lease_agreements/renew_lease";
export const update_lease_status =
  "/api/app/lease_management/lease_agreements/update_lease_status";
export const add_lease_agreement =
  "/api/app/lease_management/lease_templates/add_lease_agreement";
export const get_lease_templates =
  "/api/app/lease_management/lease_templates/get_lease_templates";
export const get_lease_template =
  "/api/app/lease_management/lease_templates/get_lease_template";
export const update_lease_template =
  "/api/app/lease_management/lease_templates/update_lease_template";
export const delete_lease_template =
  "/api/app/lease_management/lease_templates/delete_lease_template";
export const get_lease_data_for_template =
  "/api/app/lease_management/lease_templates/get_lease_data_for_template";
export const create_lease_penalty =
  "/api/app/lease_management/lease_penalties/create_lease_penalty";
export const get_lease_penalty =
  "/api/app/lease_management/lease_penalties/get_single_penalty";
export const get_lease_penalties =
  "/api/app/lease_management/lease_penalties/get_lease_penalties";
export const update_lease_penalty =
  "/api/app/lease_management/lease_penalties/update_lease_penalty";
export const create_lease_reminder =
  "/api/app/lease_management/lease_reminders/create_lease_reminder";
export const get_lease_reminders =
  "/api/app/lease_management/lease_reminders/get_lease_reminders";
export const get_lease_reminder =
  "/api/app/lease_management/lease_reminders/get_single_reminder";
export const update_lease_reminder =
  "/api/app/lease_management/lease_reminders/update_lease_reminder";
export const toggle_lease_reminder_status =
  "/api/app/lease_management/lease_reminders/reminder_status";
export const generate_tenant_invoice =
  "/api/app/lease_management/lease_agreements/generate_tenant_invoice";
export const toggle_lease_penalty_status =
  "/api/app/lease_management/lease_penalties/penalty_status";

export const generate_facility_invoice =
  "/api/app/lease_management/lease_agreements/generate_facility_invoices";

// Lease Reports

export const get_rent_roll_report =
  "/api/app/lease_management/lease_reports/rent-roll";

export const get_lease_expiry_pipeline =
  "/api/app/lease_management/lease_reports/expiry-pipeline";

export const get_rent_escalation_tracker =
  "/api/app/lease_management/lease_reports/rent-escalation";

export const get_unbilled_report =
  "/api/app/lease_management/lease_reports/unbilled";

// Levy Reports

export const get_levy_collection_vs_budget =
  "/api/app/levy_management/levy_reports/collection_vs_budget";

export const get_levy_aging_report =
  "/api/app/levy_management/levy_reports/levy_aging";

export const get_levy_compliance_report =
  "/api/app/levy_management/levy_reports/levy_facility_compliance";

export const get_levy_reconciliation_report =
  "/api/app/levy_management/levy_reports/levy_reconciliation";

export const get_levy_payments_received_report =
  "/api/app/levy_management/levy_reports/levy_reconciliation";
export const get_levy_invoices_raised_report =
  "/api/app/levy_management/levy_reports/levy_reconciliation";

// nelson reports
export const getLeaseBalancesURL =
  "/api/app/lease_management/lease_balances/get_lease_balances";

export const getTicketReportsURL = "/api/app/ticket_management/ticket_reports";

export const getMonthlySummaryURL = "/api/app/ticket_management/ticket_reports";

// handover management
export const create_move_in_handover =
  "/api/app/handover_management/move_in_handover";
export const create_move_out_handover =
  "/api/app/handover_management/move_out_handover";
export const get_all_handovers =
  "/api/app/handover_management/get_all_handovers";
export const get_handover = "/api/app/handover_management/get_handover";
export const update_handover = "/api/app/handover_management/update_handover";
export const delete_handover = "/api/app/handover_management/delete_handover";
export const compare_handovers =
  "/api/app/handover_management/compare_handovers";
export const upload_handover_images =
  "/api/app/handover_management/upload_images";
export const get_handover_aggregate_data =
  "/api/app/handover_management/get_handover_aggregate_data";
export const get_handover_share_link =
  "/api/app/handover_management/share_link";
export const public_handover_pdf =
  "/api/app/handover_management/public/handover_pdf";
export const send_handover_email = "/api/app/handover_management/send_email";
export const send_handover_sms = "/api/app/handover_management/send_sms";
export const getUnpaidInvoicesForUnit =
  "/api/app/handover_management/getUnpaidInvoicesForUnit";

// handover reports
export const get_handover_summary_report =
  "/api/app/handover_management/reports/handover-summary";
export const get_inventory_comparison_report =
  "/api/app/handover_management/reports/inventory-comparison";
export const get_meter_readings_report =
  "/api/app/handover_management/reports/meter-readings";
export const get_handover_completion_report =
  "/api/app/handover_management/reports/completion-metrics";

//home inspection
export const get_all_inspection_settings =
  "/api/app/handover_management/get_all_inspection_settings";
export const get_unit_inspection_items =
  "/api/app/handover_management/get_unit_inspection_items";
export const get_inspection_settings_by_id =
  "/api/app/handover_management/get_inspection_settings_by_id";
export const add_inspection_settings =
  "/api/app/handover_management/add_inspection_settings";
export const update_inspection_settings =
  "/api/app/handover_management/update_inspection_settings";
export const delete_inspection_settings =
  "/api/app/handover_management/delete_inspection_settings";
export const get_default_inspection_settings =
  "/api/app/handover_management/get_default_inspection_settings";
export const get_units_with_move_in =
  "/api/app/handover_management/units_with_move_in";
export const set_default_inspection_settings =
  "/api/app/handover_management/set_default_inspection_settings";
export const get_inspection_settings_by_category =
  "/api/app/handover_management/get_inspection_settings_by_category";

// inspection categories
export const add_inspection_category =
  "/api/app/handover_management/handover_inspection/add_inspection_category";
export const get_inspection_categories =
  "/api/app/handover_management/handover_inspection/get_inspection_categories";
export const update_inspection_category =
  "/api/app/handover_management/handover_inspection/update_inspection_category";
export const delete_inspection_category =
  "/api/app/handover_management/handover_inspection/delete_inspection_category";

// invoice settings

export const ADD_INVOICE_SCHEDULE_URL =
  "/api/app/settings_management/add_invoice_schedule";
export const GET_INVOICE_SCHEDULE_URL =
  "/api/app/settings_management/get_invoice_schedules";
export const EDIT_INVOICE_SCHEDULE_URL =
  "/api/app/settings_management/edit_schedule_date";

// Expense and Budget Management Routes

// Expense
export const addExpense = "/api/app/expense_management/add_expense";
export const getExpenses = "/api/app/expense_management/get_expenses";
export const deleteExpense = "/api/app/expense_management/delete_expense";
export const editExpense = "/api/app/expense_management/edit_expense";

// Expense Category Routes
export const addExpenseCategory =
  "/api/app/expense_management/expense_category/add_expense_category";
export const getExpenseCategories =
  "/api/app/expense_management/expense_category/get_all_expense_categories";
export const deleteExpenseCategory =
  "/api/app/expense_management/expense_category/delete_expenase_category";

// Budget
export const getBudgets = "/api/app/expense_management/get_budgets";
export const addBudget = "/api/app/expense_management/add_budget";
export const deleteBudget = "/api/app/expense_management/delete_budget";
export const editBudget = "/api/app/expense_management/edit_budget";
export const getBudget = "/api/app/expense_management/get_budget";
export const approveBudget = "/api/app/expense_management/approve";

// Utilities
export const analog_base_url = "/api/app/analog-meters";
export const smart_meters_base_url = "/api/app/water-meters";
export const enforcementUpdate = "/api/app/water-meters/enforcement";
export const meters_readings_base_url = "/api/app/water-meters/readings";
export const customer_account_base_url = "/api/app/customer-account";
export const customerBillingTriggerURL = (facilityId, customerId) =>
  `/api/app/analog-meters/trigger-billing/${facilityId}/customer/${customerId}`;
export const get_customer_single_account =
  "/api/app/customer-account/get_customer_account";

// Utilities Reports
export const GET_WATER_CONSUMPTION_REPORT_URL =
  "/api/app/utility_management/reports/facility_consumptions";
export const GET_BILLING_SUMMARY_REPORT_URL =
  "/api/app/utility_management/reports/facility_water_billing";
export const GET_ARREARS_AGING_REPORT_URL =
  "/api/app/utility_management/reports/facility_water_arrears_aging";
export const GET_PAYMENT_REPORTS_URL =
  "/api/app/utility_management/reports/facility_payments";

//Currencies
export const ADD_CURRENCY_URL = "/api/app/settings_management/add_currency";
export const GET_CURRENCIES_URL = "/api/app/settings_management/get_currencies";
export const DELETE_CURRENCY_URL =
  "/api/app/settings_management/delete_currency";
export const EDIT_CURRENCY_URL = "/api/app/settings_management/edit_currency";

// GL Accounts Management URLs
export const getGLAccountsURL = "/api/v1/gl-accounts";
export const getFinalGLAccountsURL = "/api/v1/gl-accounts/final-accounts";

//Departments
export const ADD_DEPARTMENT_URL = "/api/app/settings_management/add_department";
export const GET_DEPARTMENT_URL =
  "/api/app/settings_management/get_departments";
export const DELETE_DEPARTMENT_URL =
  "/api/app/settings_management/delete_department";
export const EDIT_DEPARTMENT_URL =
  "/api/app/settings_management/edit_department";
//Delivery Time Marks on PO
export const add_delivery_time_mark =
  "/api/app/procurement_management/controllers/po_payment_grading/add_delivery_time_mark";
export const get_delivery_time_marks =
  "/api/app/procurement_management/controllers/po_payment_grading/get_all_delivery_time_marks";
export const delete_delivery_time_mark =
  "/api/app/procurement_management/controllers/po_payment_grading/delete_delivery_time_mark";
export const edit_delivery_time_mark =
  "/api/app/procurement_management/controllers/po_payment_grading/edit_delivery_time_mark";

//Payment Terms Marks on PO
export const add_payment_term_mark =
  "/api/app/procurement_management/controllers/po_payment_grading/add_payment_term_mark";
export const get_payment_term_marks =
  "/api/app/procurement_management/controllers/po_payment_grading/get_all_payment_term_mark";
export const delete_payment_term_mark =
  "/api/app/procurement_management/controllers/po_payment_grading/delete_payment_term_mark";
export const edit_payment_term_mark =
  "/api/app/procurement_management/controllers/po_payment_grading/edit_payment_term_mark";

// Water Meter Settings Urls
export const ADD_WATER_METER_SETTINGS_URL =
  "/api/app/settings_management/add-meter-settings";
export const GET_WATER_METER_SETTINGS_URL =
  "/api/app/settings_management/get-meter-settings";
export const UPDATE_WATER_METER_SETTINGS_URL =
  "/api/app/settings_management/update-settings";
export const getWaterInvoice = "/api/app/water-invoices/account";
export const getUnitMeterHistory = "/api/app/analog-meters/meter";

//Power Meter Settings Urls
export const ADD_POWER_METER_SETTINGS_URL =
  "/api/app/settings_management/add-meter-settings";
export const GET_POWER_METER_SETTINGS_URL =
  "/api/app/settings_management/add-meter-settings";
export const UPDATE_POWER_METER_SETTINGS_URL =
  "/api/app/settings_management/add-meter-settings";
export const ADD_POWER_CHARGE_URL =
  "/api/app/settings_management/add-meter-settings";
export const GET_POWER_CHARGES_URL =
  "/api/app/settings_management/add-meter-settings";
export const UPDATE_POWER_CHARGE_URL =
  "/api/app/settings_management/add-meter-settings";
export const DELETE_POWER_CHARGE_URL =
  "/api/app/settings_management/add-meter-settings";

//Payment management
export const getCashPayments =
  "/api/app/payment_management/cash/get_cash_payments";
export const approveCashPayment =
  "/api/app/payment_management/cash/approve_cash_payment";
export const rejectCashPayment =
  "/api/app/payment_management/cash/reject_cash_payment";
export const voidCashPayment =
  "/api/app/payment_management/cash/void_cash_payment";
export const recordCashPayment =
  "/api/app/payment_management/cash/record_cash_payment";
export const recordWhtPayment = "/api/app/payment_management/record_wht";
export const recordLandlordWalletPayment =
  "/api/app/payment_management/record_landlord_wallet_payment";
export const getPendingWithdrawalsURL =
  "/api/landlord/wallet_management/get_pending_withdrawals";
export const approveWalletWithdrawalURL =
  "/api/landlord/wallet_management/approve_withdrawal";
export const rejectWalletWithdrawalURL =
  "/api/landlord/wallet_management/reject_withdrawal";
export const getWalletBalanceURL =
  "/api/landlord/wallet_management/get_wallet_balance";
export const getUnpaidInvoices =
  "/api/app/payment_management/get_unpaid_invoices";
export const applyOverpayment = "/api/app/payment_management/apply_overpayment";
export const get_credit_invoices =
  "/api/app/payment_management/get_credit_invoices";
export const resendInvoiceNotification =
  "/api/app/payment_management/resend_invoice_notification";
export const fetchPropertyManagersURL =
  "/api/app/payment_management/get_property_managers";
export const sendInvoiceToManager =
  "/api/app/payment_management/send_invoice_to_manager";
export const voidInvoice = "/api/app/payment_management/void_invoice";
export const checkPendingCashPaymentURL =
  "/api/app/payment_management/cash/check_pending_payment";
export const cancelInvoice = "/api/app/payment_management/cancel_invoice";
export const transferCredit = "/api/app/payment_management/transfer_credit";
export const getUnauthenticatedCustomerInformation =
  "/api/app/settings_management/get_unauthenticated_customer_information";

// campaign urls
export const addCampaignURL = "/api/app/campaign_management/add_campaign";
export const getCampaignsURL = "/api/app/campaign_management/get_campaigns";
export const getCampaignURL = "/api/app/campaign_management/get_campaign";
export const updateCampaignURL = "/api/app/campaign_management/update_campaign";
export const getInvoiceReconciliation =
  "/api/app/payment_management/get_invoice_reconciliation";

//Booking Management
export const createBookingPropertyURL =
  "/api/app/booking_management/create_booking_property";
export const updateBookingPropertyURL =
  "/api/app/booking_management/update_booking_property";
export const getAllBookingPropertiesURL =
  "/api/app/booking_management/get_all_units_and_booking_properties";
export const getBookingPropertyURL =
  "/api/app/booking_management/get_booking_property";
export const blockPropertyDatesURL =
  "/api/app/booking_management/block_property_dates";
export const togglePropertyListingURL =
  "/api/app/booking_management/toggle_property_listing";
export const getAirbnbEligibleUnitsURL =
  "/api/app/booking_management/get_airbnb_eligible_units";
export const getBookingBlockedDatesURL =
  "/api/app/booking_management/get_booking_blocked_dates";

export const createBookingReservationURL =
  "/api/app/booking_management/booking_reservation/create_reservation";
export const updateBookingStatusURL =
  "/api/app/booking_management/booking_reservation/update_booking_status";
export const getAllReservationsURL =
  "/api/app/booking_management/booking_reservation/get_all_reservations";
export const getReservationURL =
  "/api/app/booking_management/booking_reservation/get_reservation";
export const calculateBookingPriceURL =
  "/api/app/booking_management/booking_reservation/calculate_booking_price";
export const checkAvailableDatesURL =
  "/api/app/booking_management/booking_reservation/check_available_dates";
export const getBookingDashboardStatsURL =
  "/api/app/booking_management/booking_reservation/get_booking_dashboard_stats";
export const generateBookingInvoiceURL =
  "/api/app/booking_management/booking_reservation/generate_booking_invoice";
export const checkoutReservationURL =
  "/api/app/booking_management/booking_reservation/checkout_reservation";
export const checkInReservationURL =
  "/api/app/booking_management/booking_reservation/check_in_reservation";
export const getBookingConfigURL =
  "/api/app/booking_management/get_booking_config";
export const updateBookingConfigURL =
  "/api/app/booking_management/update_booking_config";
export const cancellationPolicyURL =
  "/api/app/booking_management/cancellation_policy";
export const uploadBookingPropertyImagesURL =
  "/api/app/booking_management/upload_booking_property_images";
export const deleteBookingPropertyImageURL =
  "/api/app/booking_management/delete_booking_property_image";
export const getReservationTrendURL =
  "/api/app/booking_management/booking_reservation/get_reservation_trend";
export const calculate_revenue_trends =
  "/api/app/booking_management/booking_reservation/calculate_revenue_trends";
export const record_checkout_for_revenue =
  "/api/app/booking_management/booking_reservation/record_checkout_revenue";
//Booking Invoices
export const GetBookingInvoicesURL =
  "/api/app/booking_management/booking_invoice/get_all_booking_invoices";
export const GetBookingInvoiceDetailsURL =
  "/api/app/booking_management/booking_invoice/get_booking_invoice_details";
export const GetBookingRefundsURL =
  "/api/app/booking_management/booking_invoice/get_booking_refunds";
export const UpdateBookingInvoicePaymentURL =
  "/api/app/booking_management/booking_invoice/update_booking_invoice_payment";
export const GetFacilityPaybillsURL =
  "/api/app/booking_management/get_facility_paybills";

// Customer Management URLs
export const getCustomerPhoneNumberURL =
  "/api/app/customer_management/get_customer_number";

// Procurement URLS

// Suppliers Urls
export const addSuplierUrl = "/api/app/suppliers/add";
export const getSupplierUrl = "/api/app/suppliers/details";
export const updateSupplierURL = "/api/app/suppliers/update";
export const getSuppliersUrl = "/api/app/suppliers/all";

// Purchase Requests Urls
export const addPurchaseRequestsUrl = "/api/app/purchase-requests/add";
export const getPurchaseRequestUrl = "/api/app/purchase-requests/details";
export const updatePurchaseRequestURL = "/api/app/purchase-requests/update";
export const getPurchaseRequestsUrl = "/api/app/purchase-requests/all";

// Quotations Requests Urls
export const addQuotationRequestsUrl = "/api/app/quotations/add";
export const getQuotationRequestUrl = "/api/app/quotations/details";
export const updateQuotationRequestURL = "/api/app/quotations/update";
export const getQuotationRequestsUrl = "/api/app/quotations/all";

//Purchase Orders Requests Urls
export const addPurchaseOrderRequestsUrl = "/api/app/purchase-orders/add";
export const getPurchaseOrderRequestUrl = "/api/app/purchase-orders/details";
export const updatePurchaseOrderRequestURL = "/api/app/purchase-orders/update";
export const getPurchaseOrderRequestsUrl = "/api/app/purchase-orders/all";

// Approvals  Requests Urls
export const addApprovalWorkflowRequestsUrl = "/api/app/approval-workflows/add";
export const getApprovalWorkflowRequestUrl =
  "/api/app/approval-workflows/details";
export const updateApprovalWorkflowRequestURL =
  "/api/app/approval-workflows/update";
export const getApprovalWorkflowRequestsUrl = "/api/app/approval-workflows/all";
export const deleteApprovalWorkflowRequestsUrl =
  "/api/app/approval-workflows/delete";
export const getRfqDetailsUrl = "/api/app/quotations/by_id";

// RFQS Response  Requests Urls
export const addRFQResponseRequestsUrl = "/api/app/rfq-responses/add";
export const getRFQResponsesRequestUrl = "/api/app/rfq-responses/details";
export const updateRFQResponseRequestURL =
  "/api/app/quotations-response/update";
export const getRFQResponseByIdUrl = "/api/app/quotations-response/all";

export const statementOfAccountsURL =
  "/api/app/customer_management/get_statement_of_accounts";
export const uploadCustomerDocumentURL =
  "/api/app/customer_management/upload_customer_documents";
export const getCustomerDocumentsURL =
  "/api/app/customer_management/get_customer_documents";
export const uploadUnitDocumentURL =
  "/api/app/unit_management/upload_unit_documents";
export const getUnitDocumentsURL =
  "/api/app/unit_management/get_unit_documents";
export const unitStatementOfAccountsURL =
  "/api/app/unit_management/get_unit_statement_of_accounts";
export const getUnitInvoiceTransactionsURL =
  "/api/app/unit_management/get_unit_invoices";
export const getLandlordUnpaidInvoices =
  "/api/app/unit_management/get_landlord_unpaid_invoices";

// Common Area Electricity Routes
export const addCommonAreaElectricityReadingUrl =
  "/api/app/common-area/electricity/add";
export const getCommonAreaElectricityReadingUrl =
  "/api/app/common-area/electricity/get_details";
export const updateCommonAreaElectricityReadingURL =
  "/api/app/common-area/electricity/update_reading";
export const getCommonAreaElectricityReadingsUrl =
  "/api/app/common-area/electricity/get_all";

// Common Area Water Routes
export const addCommonAreaWaterReadingUrl = "/api/app/common-area/water/add";
export const getCommonAreaWaterReadingUrl =
  "/api/app/common-area/water/get_details";
export const updateCommonAreaWaterReadingURL =
  "/api/app/common-area/water/update_reading";
export const getCommonAreaWaterReadingsUrl =
  "/api/app/common-area/water/get_all";

// Common Area Generator Routes
export const addCommonAreaGeneratorReadingUrl =
  "/api/app/common-area/generator/add";
export const getCommonAreaGeneratorReadingUrl =
  "/api/app/common-area/generator/get_details";
export const updateCommonAreaGeneratorReadingURL =
  "/api/app/common-area/generator/update_reading";
export const getCommonAreaGeneratorReadingsUrl =
  "/api/app/common-area/generator/get_all";

//GL accounts routes (commented out duplicate)
// export const getGLAccountsURL = "/api/v1/gl-accounts/final-accounts";

// Cron jobs
export const getCronJobsURL = "/api/app/cronjob_management/get_cronjobs";

// Notifications
export const notificationsBaseUrl = "/api/app/notifications";
export const GET_FACILITY_INVOICES =
  "/api/app/power_meter_management/controllers/invoicing/invoices/facility";
// Bank Details Management URLs
export const getBankDetailsURL =
  "/api/app/settings_management/get_bank_details";
export const addBankDetailsURL =
  "/api/app/settings_management/add_bank_details";
export const updateBankDetailsURL =
  "/api/app/settings_management/update_bank_details";
export const deleteBankDetailsURL =
  "/api/app/settings_management/delete_bank_details";
export const getBankDetailsByIdURL =
  "/api/app/settings_management/get_bank_details_by_id";
// Biller Address Management URLs
export const getBillerAddressesURL =
  "/api/app/settings_management/get_biller_addresses";
export const addBillerAddressURL =
  "/api/app/settings_management/add_biller_address";
export const updateBillerAddressURL =
  "/api/app/settings_management/update_biller_address";
export const deleteBillerAddressURL =
  "/api/app/settings_management/delete_biller_address";
export const getBillerAddressByIdURL =
  "/api/app/settings_management/get_biller_address_by_id";
export const addFAQURL = "/api/app/settings_management/add_faq";
export const getFAQsURL = "/api/app/settings_management/get_faqs";
export const getOfflineFAQsURL =
  "/api/app/settings_management/get_offline_faqs";
export const addPrivacyPolicyURL =
  "/api/app/settings_management/add_privacy_policy";
export const getPrivacyPolicyURL =
  "/api/app/settings_management/get_privacy_policy";
export const addTermsAndConditionsURL =
  "/api/app/settings_management/add_terms_and_conditions";
export const getTermsAndConditionsURL =
  "/api/app/settings_management/get_terms_and_conditions";
export const addCommunityGuidelinesURL =
  "/api/app/settings_management/add_community_guidelines";
export const getCommunityGuidelinesURL =
  "/api/app/settings_management/get_community_guidelines";
// Bank details for levy
export const getBankDetailsForLevyURL = `/api/app/settings_management/get_bank_details_for_levy`;

// Biller address for levy
export const getBillerAddressForLevyURL = `/api/app/settings_management/get_biller_address_for_levy`;

// Facility payment details
export const getFacilityPaymentDetailsURL = `/api/app/settings_management/get_facility_payment_details`;

// Facility Paybills
export const getFacilityPaybillsDetailsURL = `/api/core/facility_payment_details/get_facility_payment_details`;

// Zoho Books Integration URLs
export const getZohoConfigURL = (facilityId) =>
  `/api/app/settings_management/get_zoho_config/${facilityId}`;
export const saveZohoConfigURL = (facilityId) =>
  `/api/app/settings_management/add_zoho_config/${facilityId}`;
export const updateZohoConfigURL = (facilityId) =>
  `/api/app/settings_management/update_zoho_config/${facilityId}`;
export const deleteZohoConfigURL = (facilityId) =>
  `/api/app/settings_management/delete_zoho_config/${facilityId}`;
export const testZohoConnectionURL = (facilityId) =>
  `/api/app/settings_management/test_zoho_connection/${facilityId}`;
export const disconnectZohoURL = (facilityId) =>
  `/api/app/settings_management/disconnect_zoho/${facilityId}`;
export const refreshZohoTokenURL = (facilityId) =>
  `/api/app/settings_management/refresh_zoho_token/${facilityId}`;
export const syncZohoInvoiceURL = (facilityId) =>
  `/api/app/settings_management/sync_zoho_invoice/${facilityId}`;
export const syncZohoPaymentURL = (facilityId) =>
  `/api/app/settings_management/sync_zoho_payment/${facilityId}`;
export const getZohoSyncStatusURL = (facilityId) =>
  `/api/app/settings_management/get_zoho_sync_status/${facilityId}`;
export const syncRetainerToZohoURL = (facilityId, contractId) =>
  `/api/app/levy_management/sync_retainer_to_zoho/${facilityId}/${contractId}`;
export const checkFacilityZohoConfigURL = (facilityId) =>
  `/api/app/settings_management/get_zoho_config/${facilityId}`;

// eTims (KRA Electronic Tax Invoice Management System) Integration URLs
export const getEtimsConfigURL = (facilityId) =>
  `/api/app/settings_management/get_etims_config/${facilityId}`;
export const saveEtimsConfigURL = (facilityId) =>
  `/api/app/settings_management/add_etims_config/${facilityId}`;
export const updateEtimsConfigURL = (facilityId) =>
  `/api/app/settings_management/update_etims_config/${facilityId}`;
export const deleteEtimsConfigURL = (facilityId) =>
  `/api/app/settings_management/delete_etims_config/${facilityId}`;
export const testEtimsConnectionURL = (facilityId) =>
  `/api/app/settings_management/test_etims_connection/${facilityId}`;
export const disconnectEtimsURL = (facilityId) =>
  `/api/app/settings_management/disconnect_etims/${facilityId}`;
export const getEtimsHealthURL = () => `/api/integrations/etims/health`;
export const syncEtimsInvoiceURL = (facilityId) =>
  `/api/app/settings_management/sync_etims_invoice/${facilityId}`;
export const getEtimsPendingInvoicesURL = (facilityId) =>
  `/api/app/settings_management/get_etims_pending_invoices/${facilityId}`;
export const retryEtimsInvoiceURL = (facilityId, invoiceId) =>
  `/api/app/settings_management/retry_etims_invoice/${facilityId}/${invoiceId}`;

//Quickbooks urls

// Get QuickBooks configuration(s) for a facility.
// Multi-realm: returns an ARRAY of connection objects.
export const getQuickBooksConfigURL = (facilityId) =>
  `/api/app/settings_management/get_quickbooks_config/${facilityId}`;

// Save (create) a new QuickBooks connection/realm for a facility
export const saveQuickBooksConfigURL = (facilityId) =>
  `/api/app/settings_management/add_quickbooks_config/${facilityId}`;

// Update an existing QuickBooks connection.
// Multi-realm: caller must include `qbConfigId` identifying which
// connection to update (sent in the request body).
export const updateQuickBooksConfigURL = (facilityId) =>
  `/api/app/settings_management/update_quickbooks_config/${facilityId}`;

// Delete a QuickBooks connection.
// Multi-realm: caller must include `qbConfigId` identifying which
// connection to delete (sent in the request body).
export const deleteQuickBooksConfigURL = (facilityId) =>
  `/api/app/settings_management/delete_quickbooks_config/${facilityId}`;

// Connect to QuickBooks (OAuth redirect flow).
// Multi-realm: pass the `qbConfigId` of the connection being authorized;
// it is forwarded as a query param since this is a browser redirect, not
// a fetch call.
export const connectQuickBooksURL = (facilityId, qbConfigId) => {
  const base = `/api/app/settings_management/connect_quickbooks/${facilityId}`;
  return qbConfigId
    ? `${base}?qbConfigId=${encodeURIComponent(qbConfigId)}`
    : base;
};

// Disconnect QuickBooks (revoke tokens).
// Multi-realm: caller must include `qbConfigId` identifying which
// connection to disconnect (sent in the request body).
export const disconnectQuickBooksURL = (facilityId) =>
  `/api/app/settings_management/disconnect_quickbooks/${facilityId}`;

// Manually trigger a catch-up sync of not-yet-synced invoices/payments (etc.)
// for one realm. Fire-and-forget on the backend (returns 202 immediately) --
// poll getQuickBooksOutboundSyncStatusURL for progress. qbConfigId travels as
// a query param here even though this is a POST (confirmed from the
// controller, which reads request.query.qbConfigId, not the body). It's
// optional -- the backend falls back to the facility's default realm when
// omitted, which is what the single-realm QuickBooksOutboundSync UI does.
export const runQuickBooksOutboundSyncURL = (facilityId, qbConfigId) =>
  `/api/app/settings_management/run_quickbooks_outbound_sync/${facilityId}${qbConfigId ? `?qbConfigId=${encodeURIComponent(qbConfigId)}` : ""}`;

export const getQuickBooksOutboundSyncStatusURL = (facilityId, qbConfigId) =>
  `/api/app/settings_management/get_quickbooks_outbound_sync_status/${facilityId}${qbConfigId ? `?qbConfigId=${encodeURIComponent(qbConfigId)}` : ""}`;

// ============================================
// QUICKBOOKS ACCOUNT / ITEM / PAYMENT CHANNEL MAPPING URLs
// Multi-realm: `qbConfigId` travels as a query param on GET/DELETE and as
// a body field on POST -- callers must supply it.
// ============================================

// -- Chart of Accounts --
export const getAccountMappingSuggestionsURL = (facilityId, qbConfigId) =>
  `/api/app/settings_management/get_account_mapping_suggestions/${facilityId}?qbConfigId=${encodeURIComponent(qbConfigId || "")}`;
export const getAccountMappingsURL = (facilityId, qbConfigId) =>
  `/api/app/settings_management/get_account_mappings/${facilityId}?qbConfigId=${encodeURIComponent(qbConfigId || "")}`;
export const saveAccountMappingURL = (facilityId) =>
  `/api/app/settings_management/save_account_mapping/${facilityId}`;
export const bulkSaveAccountMappingsURL = (facilityId) =>
  `/api/app/settings_management/bulk_save_account_mappings/${facilityId}`;
export const deleteAccountMappingURL = (
  facilityId,
  payserveAccountId,
  qbConfigId,
) =>
  `/api/app/settings_management/delete_account_mapping/${facilityId}/${payserveAccountId}?qbConfigId=${encodeURIComponent(qbConfigId || "")}`;

// -- Items --
export const getItemMappingSuggestionsURL = (facilityId, qbConfigId) =>
  `/api/app/settings_management/get_item_mapping_suggestions/${facilityId}?qbConfigId=${encodeURIComponent(qbConfigId || "")}`;
export const getItemMappingsURL = (facilityId, qbConfigId) =>
  `/api/app/settings_management/get_item_mappings/${facilityId}?qbConfigId=${encodeURIComponent(qbConfigId || "")}`;
export const saveItemMappingURL = (facilityId) =>
  `/api/app/settings_management/save_item_mapping/${facilityId}`;
export const bulkSaveItemMappingsURL = (facilityId) =>
  `/api/app/settings_management/bulk_save_item_mappings/${facilityId}`;
export const deleteItemMappingURL = (facilityId, category, qbConfigId) =>
  `/api/app/settings_management/delete_item_mapping/${facilityId}/${category}?qbConfigId=${encodeURIComponent(qbConfigId || "")}`;
export const createAndMapItemURL = (facilityId) =>
  `/api/app/settings_management/create_and_map_item/${facilityId}`;

// -- Payment Channels --
export const getPaymentChannelMappingSuggestionsURL = (
  facilityId,
  qbConfigId,
) =>
  `/api/app/settings_management/get_payment_channel_mapping_suggestions/${facilityId}?qbConfigId=${encodeURIComponent(qbConfigId || "")}`;
export const getPaymentChannelMappingsURL = (facilityId, qbConfigId) =>
  `/api/app/settings_management/get_payment_channel_mappings/${facilityId}?qbConfigId=${encodeURIComponent(qbConfigId || "")}`;
export const savePaymentChannelMappingURL = (facilityId) =>
  `/api/app/settings_management/save_payment_channel_mapping/${facilityId}`;
export const bulkSavePaymentChannelMappingsURL = (facilityId) =>
  `/api/app/settings_management/bulk_save_payment_channel_mappings/${facilityId}`;
export const deletePaymentChannelMappingURL = (
  facilityId,
  channel,
  qbConfigId,
) =>
  `/api/app/settings_management/delete_payment_channel_mapping/${facilityId}/${channel}?qbConfigId=${encodeURIComponent(qbConfigId || "")}`;

// QuickBooks live chart-of-accounts / items lookups (used to populate
// mapping suggestion pickers before a mapping row is saved).
export const getQuickBooksLiveAccountsURL = (facilityId) =>
  `/api/app/settings_management/get_quickbooks_live_accounts/${facilityId}`;

export const getQuickBooksLiveItemsURL = (facilityId) =>
  `/api/app/settings_management/get_quickbooks_live_items/${facilityId}`;

// Apply a previously synced QuickBooks payment to a needs-review mapping.
export const applyQuickBooksPaymentURL = (facilityId, mappingId) =>
  `/api/app/settings_management/apply_quickbooks_payment/${facilityId}/${mappingId}`;

// QuickBooks invoice / payment sync status
export const getInvoiceSyncStatusURL = (facilityId) =>
  `/api/app/settings_management/get_invoice_sync_status/${facilityId}`;

export const getPaymentSyncStatusURL = (facilityId) =>
  `/api/app/settings_management/get_payment_sync_status/${facilityId}`;

// QuickBooks CDC reconciliation sweep
export const runQuickBooksCdcSweepURL = (facilityId) =>
  `/api/app/settings_management/run_quickbooks_cdc_sweep/${facilityId}`;

export const getQuickBooksCdcSweepStatusURL = (facilityId) =>
  `/api/app/settings_management/get_quickbooks_cdc_sweep_status/${facilityId}`;

// QuickBooks full historical backfill (beyond CDC's 30-day window)
export const runQuickBooksBackfillURL = (facilityId) =>
  `/api/app/settings_management/run_quickbooks_backfill/${facilityId}`;

export const getQuickBooksBackfillStatusURL = (facilityId) =>
  `/api/app/settings_management/get_quickbooks_backfill_status/${facilityId}`;

export const getAccountSnapshotsURL = (facilityId) =>
  `/api/app/settings_management/get_account_snapshots/${facilityId}`;

// QuickBooks customer sync (Home Owner / Tenant <-> QuickBooks Customer)
export const getCustomerSyncStatusURL = (facilityId) =>
  `/api/app/settings_management/get_customer_sync_status/${facilityId}`;

export const resyncCustomerURL = (facilityId) =>
  `/api/app/settings_management/resync_customer/${facilityId}`;

export const listNeedsReviewCustomersURL = (facilityId) =>
  `/api/app/settings_management/list_needs_review_customers/${facilityId}`;

export const resolvePendingCustomerURL = (facilityId, mappingId) =>
  `/api/app/settings_management/resolve_pending_customer/${facilityId}/${mappingId}`;

// QuickBooks vendor directory sync (Supplier <-> QuickBooks Vendor)
export const getVendorSyncStatusURL = (facilityId) =>
  `/api/app/settings_management/get_vendor_sync_status/${facilityId}`;

export const resyncVendorURL = (facilityId) =>
  `/api/app/settings_management/resync_vendor/${facilityId}`;

export const listNeedsReviewVendorsURL = (facilityId) =>
  `/api/app/settings_management/list_needs_review_vendors/${facilityId}`;

export const resolvePendingVendorURL = (facilityId, mappingId) =>
  `/api/app/settings_management/resolve_pending_vendor/${facilityId}/${mappingId}`;

export const GET_ACCOUNT_CUSTOMER_INVOICES =
  "/api/app/power_meter_management/controllers/invoicing/invoices/account/:accountNumber/customer/:customerId";
export const getPowerInvoice =
  "/api/app/power_meter_management/controllers/invoicing/invoices";
export const sendPowerInvoiceNotificationURL =
  "/api/app/power_meter_management/controllers/invoicing/invoices";

export const GET_MONEY_COLLECTED_REPORT_URL =
  "/api/app/utility_management/reports/money_collected_per_account";
export const GET_COLLECTED_MONEY_REPORT_URL =
  "/api/app/utility_management/reports/collected_money";
export const GET_CONSUMPTION_REPORT_URL =
  "/api/app/utility_management/reports/consumption_by_category";
export const GET_CONSUMPTION_VS_BILLING_REPORT_URL =
  "/api/app/utility_management/reports/consumption_vs_billing";

export const GET_UNUSED_PREPAID_BALANCE_REPORT_URL =
  "/api/app/utility_management/reports/unused_prepaid_balance";
export const GET_BULK_SUPPLY_NRW_REPORT_URL =
  "/api/app/utility_management/reports/bulk_supply_nrw";
export const GET_END_OF_DAY_PAYMENTS_REPORT_URL =
  "/api/app/utility_management/reports/end_of_day_payments";

// Which connected QuickBooks realm each invoice category posts to (multi-realm).
export const getQuickBooksInvoiceRoutingURL = (facilityId) =>
  `/api/app/settings_management/get_quickbooks_invoice_routing/${facilityId}`;

export const saveQuickBooksInvoiceRoutingURL = (facilityId) =>
  `/api/app/settings_management/save_quickbooks_invoice_routing/${facilityId}`;

// QuickBooks sync status per PayServe invoice (for the invoice-list column).
export const getQuickBooksInvoiceStatusesURL = (facilityId) =>
  `/api/app/settings_management/get_quickbooks_invoice_statuses/${facilityId}`;

// Water Sensor (LoRa water tanks) service settings
export const getWaterSensorSettingsURL = (facilityId) =>
  `/api/app/settings_management/get_water_sensor_settings/${facilityId}`;
export const updateWaterSensorSettingsURL = (facilityId) =>
  `/api/app/settings_management/update_water_sensor_settings/${facilityId}`;
export const getWaterAlertSettingsURL = (facilityId) =>
  `/api/app/water_sensor_management/${facilityId}/alert_settings`;

export const updateWaterAlertSettingsURL = (facilityId) =>
  `/api/app/water_sensor_management/${facilityId}/alert_settings`;

// Water level sensors (water_level_service via backend_main), per facility
const waterSensorBaseURL = (facilityId) =>
  `/api/app/water_sensor_management/${facilityId}`;
export const getWaterSensorTanksURL = (facilityId) =>
  `${waterSensorBaseURL(facilityId)}/tanks`;
export const getWaterSensorTanksSummaryURL = (facilityId) =>
  `${waterSensorBaseURL(facilityId)}/tanks/summary`;
export const waterSensorTankURL = (facilityId, tankId) =>
  `${waterSensorBaseURL(facilityId)}/tanks/${tankId}`; // + /readings, /readings/export
export const getWaterSensorAlertsURL = (facilityId) =>
  `${waterSensorBaseURL(facilityId)}/alerts`;
export const acknowledgeWaterSensorAlertURL = (facilityId, alertId) =>
  `${waterSensorBaseURL(facilityId)}/alerts/${alertId}/acknowledge`;
export const waterSensorGatewaysURL = (facilityId) =>
  `${waterSensorBaseURL(facilityId)}/gateways`; // GET list, POST assign, + /:gatewayId DELETE
export const availableWaterSensorGatewaysURL = (facilityId) =>
  `${waterSensorBaseURL(facilityId)}/gateways/available`;


// Power reports (ported from swan_production)
export const GET_POWER_MONEY_COLLECTED_REPORT_URL =
  "/api/app/power_meter_management/controllers/reports/money_collected_report";
export const GET_FACILITY_POWER_REPORT_URL =
  "/api/app/power_meter_management/controllers/reports/facility_power_report";
export const GET_FACILITY_INVOICES_URL =
  "/api/app/power_meter_management/controllers/invoicing/invoices/facility";
export const GET_POWER_MONTHLY_USAGE_URL =
  "/api/app/power_meter_management/controllers/history_data/power_usage_monthly_graph";
export const GET_FACILITY_CONSUMPTION_TREND_URL =
  "/api/app/power_meter_management/controllers/reports/facility_consumption_trend";

// Utility (power/water) -> Zoho month-by-month sync
export const syncUtilityToZohoURL = (facilityId) =>
  `/api/app/settings_management/sync_utility_to_zoho/${facilityId}`;
export const getUtilityZohoSyncStatusURL = (facilityId) =>
  `/api/app/settings_management/sync_utility_to_zoho/${facilityId}/status`;

// Zoho item mapping (PayServe category -> Zoho Books item)
export const getZohoItemMappingSuggestionsURL = (facilityId) =>
  `/api/app/settings_management/get_zoho_item_mapping_suggestions/${facilityId}`;
export const saveZohoItemMappingURL = (facilityId) =>
  `/api/app/settings_management/save_zoho_item_mapping/${facilityId}`;
export const createAndMapZohoItemURL = (facilityId) =>
  `/api/app/settings_management/create_and_map_zoho_item/${facilityId}`;
export const deleteZohoItemMappingURL = (facilityId, category) =>
  `/api/app/settings_management/delete_zoho_item_mapping/${facilityId}/${category}`;
